import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type Props = {
  pageContent: any
  children?: ReactNode
}
export default function GameContentRender(props: Props) {
  return (
    <>
      {props?.children}
      <div
        data-testid='game-description'
        data-name={`game-descriptions-${process.env.BRAND_NAME}`}
        className={classes.gameRootContent}
        dangerouslySetInnerHTML={{ __html: props.pageContent }}
      />
    </>
  )
}
